import dynamic from 'next/dynamic';
import { useState, useRef, Fragment } from 'react';
import { useLocationState } from '../../context/location';
import { submitClientRequest } from '../../helpers/clientRequest';
import Input from '../Input';
import Textarea from '../Textarea';
import styles from '../../styles/modules/home/HomeBanner.module.scss';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../Modal'));

const HomeBanner = ({ title, text }) => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: '/',
        whatComponent: 'HomeBanner',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <section className="block">
      <Modal
        title="Обратная связь"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем
              решить все имеющиеся у Вас вопросы!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу получить консультацию перед продажей своей квартиры в городе»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <div className="fixed fill">
        <div className={styles.banner}>
          {title.map((v, i) => (
            <h2 className={styles.bannerTitle} key={i}>
              {v}
            </h2>
          ))}
          {text.map((v, i) => (
            <div className={styles.bannerSubtitle} key={i}>
              {v}
            </div>
          ))}
          <button
            className={styles.bannerButton}
            onClick={() => setIsModalVisible(true)}
            type="button"
          >
            Написать нам
          </button>
          <div className={styles.bannerIllustration}>
            <img src="/images/modul.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
